<template>
    <div class="main-content">
        <!-- Toasts de Notificação -->
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"> <router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Usuários</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Usuários</h4>
                    <span class="text-muted fs-7">Exibindo {{ users.length }} de {{ totalItems }}</span>
                </div>

                <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3"
                                @click="confirmDelete(selectedIds.length, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{
                                    selectedIds.length ? selectedIds.length : 'usuário' }})
                            </button>
                        </div>
                    </transition>

                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <button class="btn btn-pmg-primary" data-bs-toggle="modal" data-bs-target="#modalUser"
                        @click="resetForm">
                        <i class="bi bi-person-plus-fill me-1"></i> Novo Usuário
                    </button>
                </div>
            </div>

            <!-- Filtros -->
            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3">
                        <div class="col-md-10">
                            <input v-model="filter.search" type="text" class="form-control form-control-pmg"
                                placeholder="Filtrar por nome ou e-mail...">
                        </div>
                        <div class="col-md-2 d-flex">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold" @click="applyFilter">
                                <i class="bi bi-search me-1"></i> Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabela -->
            <div class="table-responsive">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 25%">Nome</th>
                            <th style="width: 35%">Contato</th>
                            <th style="width: 20%">Perfil de Acesso</th>
                            <th style="width: 15%" class="text-end">Ações</th>
                        </tr>
                    </thead>

                    <tbody v-if="users.length > 0">
                        <tr v-for="item in users" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td>
                                <input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>
                            <td class="fw-bold text-dark">
                                <div class="d-flex align-items-center">
                                    <div class="bg-light rounded-circle d-flex align-items-center justify-content-center me-3 border"
                                        style="width: 40px; height: 40px;">
                                        <i class="bi bi-person text-secondary fs-5"></i>
                                    </div>
                                    {{ item.name }}
                                </div>
                            </td>
                            <td>
                                <div class="d-flex flex-column">
                                    <span class="text-dark">{{ item.email }}</span>
                                    <small class="text-muted"><i class="bi bi-telephone me-1"></i>{{ item.phone
                                    }}</small>
                                </div>
                            </td>
                            <td>
                                <span class="badge bg-light text-secondary border px-3 py-2">
                                    <i class="bi bi-shield-lock me-1"></i>
                                    {{ item.roles && item.roles.length > 0 ? item.roles[0].name : 'Sem Perfil' }}
                                </span>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        data-bs-popper-config='{"strategy":"fixed"}'>
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0">
                                        <li><a class="dropdown-item" href="#"
                                                @click.prevent="openModal('edit', item)"><i
                                                    class="bi bi-pencil me-2"></i>Editar</a></li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li>
                                            <a class="dropdown-item text-danger" href="#"
                                                @click.prevent="confirmDelete(item)">
                                                <i class="bi bi-trash me-2"></i>Excluir
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center py-5 text-muted">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <i class="bi bi-people fs-1 mb-2 text-secondary opacity-50"></i>
                                    <span class="fw-medium">Nenhum usuário encontrado.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Carregar Mais -->
            <div class="text-center mt-4" v-if="hasMore">
                <button
                    class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                    @click="loadMore" :disabled="loading" style="min-width: 220px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                    <span>{{ loading ? 'Carregando dados...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <!-- Modal Form (Criar/Editar) -->
        <div class="modal fade" id="modalUser" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0">{{ isEditing ? 'Editar Usuário' : 'Novo Usuário' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeModalBtn"></button>
                    </div>
                    <div class="modal-body px-4">
                        <div class="mb-3">
                            <label class="form-label small fw-bold text-muted">Nome Completo <span
                                    class="text-danger">*</span></label>
                            <input v-model="form.name" type="text" class="form-control form-control-pmg"
                                placeholder="Ex: João da Silva">
                        </div>
                        <div class="mb-3">
                            <label class="form-label small fw-bold text-muted">E-mail <span
                                    class="text-danger">*</span></label>
                            <input v-model="form.email" type="email" class="form-control form-control-pmg"
                                placeholder="joao@exemplo.com">
                        </div>
                        <div class="row g-3 mb-3">
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Telefone <span
                                        class="text-danger">*</span></label>
                                <input v-model="form.phone" @input="applyPhoneMask" type="text"
                                    class="form-control form-control-pmg" placeholder="(00) 00000-0000" maxlength="15">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Perfil de Acesso <span
                                        class="text-danger">*</span></label>
                                <select v-model="form.role_id" class="form-select form-control-pmg">
                                    <option value="" disabled>Selecione...</option>
                                    <!-- Altere availableRoles para selectableRoles -->
                                    <option v-for="role in selectableRoles" :key="role.id" :value="role.id">
                                        {{ role.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Aviso sobre a senha -->
                        <div v-if="!isEditing"
                            class="alert alert-info border-0 bg-info-subtle text-info-emphasis d-flex align-items-center mt-4 mb-0"
                            role="alert">
                            <i class="bi bi-info-circle-fill me-3 fs-5"></i>
                            <div class="small">
                                A senha de acesso será gerada automaticamente de forma segura e exibida após salvar.
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pb-4 px-4">
                        <button class="btn btn-pmg-light me-2" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" :disabled="!isFormValid || loading" @click="saveUser">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ isEditing ? 'Atualizar' : 'Salvar Usuário' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Senha Gerada -->
        <div class="modal fade" id="modalGeneratedPassword" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-4">
                    <div class="text-success mb-3">
                        <i class="bi bi-check-circle-fill" style="font-size: 3rem;"></i>
                    </div>
                    <h5 class="fw-bold mb-2">Usuário Criado!</h5>
                    <p class="text-muted small mb-4">Abaixo está a senha de acesso gerada pelo sistema. Copie e envie ao
                        usuário, pois ela não será exibida novamente.</p>

                    <div class="bg-light border rounded-3 p-3 mb-4 d-flex justify-content-between align-items-center">
                        <span class="fw-bold fs-5 text-dark font-monospace">{{ generatedPassword }}</span>
                        <button class="btn btn-sm btn-outline-secondary border-0" @click="copyPassword"
                            title="Copiar Senha">
                            <i class="bi bi-copy"></i>
                        </button>
                    </div>

                    <button class="btn btn-pmg-primary w-100" data-bs-dismiss="modal">Entendi, fechar</button>
                </div>
            </div>
        </div>

        <!-- Modal Confirm Delete -->
        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">{{ isBulkDelete ? `Excluir ${selectedIds.length} usuários
                            selecionados?` : `Excluir o usuário "${itemToDelete?.name}"?` }}</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';

export default {
    data() {
        return {
            users: [],
            availableRoles: [],
            alerts: [],
            isEditing: false,

            form: {
                id: null,
                name: '',
                email: '',
                phone: '',
                role_id: ''
            },

            selectedIds: [],
            filter: { search: '' },

            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            loading: false,
            hasMore: false,

            showFilter: false,
            modalInstance: null,
            passwordModalInstance: null,
            itemToDelete: null,
            isBulkDelete: false,

            generatedPassword: ''
        }
    },
    computed: {
        isAllSelected() {
            return this.users.length > 0 && this.users.every(i => this.selectedIds.includes(i.id));
        },
        isFormValid() {
            return (this.form.name || '').trim() !== '' &&
                (this.form.email || '').trim() !== '' &&
                (this.form.phone || '').trim() !== '' &&
                this.form.role_id !== '';
        },
        selectableRoles() {
            return this.availableRoles.filter(role =>
                // Exibe o perfil se não for Administrador, OU se for o perfil que já está vinculado ao usuário sendo editado
                role.name !== 'Administrador' || role.id === this.form.role_id
            );
        }
    },
    mounted() {
        const modalElement = document.getElementById('modalUser');
        if (modalElement) {
            this.modalInstance = new window.bootstrap.Modal(modalElement);
        }

        const passModalElement = document.getElementById('modalGeneratedPassword');
        if (passModalElement) {
            this.passwordModalInstance = new window.bootstrap.Modal(passModalElement);
        }

        this.fetchUsers();
        this.fetchRoles();
    },
    methods: {
        async fetchUsers(page = 1, append = false) {
            this.loading = true;
            try {
                const params = {
                    page: page,
                    search: this.filter.search
                };
                const response = await api.get('/users', { params });
                const payload = response.data;
                const items = Array.isArray(payload) ? payload : (payload.data || []);

                const paginationData = payload.meta || payload;
                const { current_page, last_page, total } = paginationData;

                if (append) {
                    this.users = [...this.users, ...items];
                } else {
                    this.users = items;
                }

                this.currentPage = current_page || 1;
                this.lastPage = last_page || 1;
                this.totalItems = total || items.length;
                this.hasMore = this.currentPage < this.lastPage;

            } catch (error) {
                this.showAlert('Falha ao comunicar com o servidor.', 'error');
            } finally {
                this.loading = false;
            }
        },

        async fetchRoles() {
            try {
                // Presume que a rota de roles sem paginação (ou puxando muitos registros) funcione para preencher o select
                const response = await api.get('/roles', { params: { per_page: 100 } });
                const payload = response.data;
                this.availableRoles = Array.isArray(payload) ? payload : (payload.data || []);
            } catch (error) {
                console.error("Erro ao buscar perfis:", error);
            }
        },

        loadMore() {
            if (this.hasMore && !this.loading) {
                this.fetchUsers(this.currentPage + 1, true);
            }
        },

        applyFilter() {
            this.showFilter = false;
            this.selectedIds = [];
            this.fetchUsers(1, false);
        },

        resetForm() {
            this.isEditing = false;
            this.form = { id: null, name: '', email: '', phone: '', role_id: '' };
        },

        openModal(mode, item = null) {
            this.resetForm();
            if (mode === 'edit') {
                this.isEditing = true;

                let roleId = '';
                if (item.roles && item.roles.length > 0) {
                    roleId = item.roles[0].id;
                }

                this.form = {
                    id: item.id,
                    name: item.name || '',
                    email: item.email || '',
                    phone: item.phone || '', // <-- Garante que receba string vazia ao invés de nulo
                    role_id: roleId
                };
            }
            if (this.modalInstance) {
                this.modalInstance.show();
            }
        },

        async saveUser() {
            this.loading = true;

            try {
                if (this.isEditing) {
                    const response = await api.put(`/users/${this.form.id}`, this.form);
                    const updatedUser = response.data.data || response.data;

                    const index = this.users.findIndex(u => u.id === this.form.id);
                    if (index !== -1) {
                        this.users[index] = updatedUser;
                        this.showAlert("Usuário atualizado com sucesso!");
                    }
                    this.modalInstance.hide();

                } else {
                    const response = await api.post('/users', this.form);
                    const newUser = response.data.data || response.data;

                    this.users.unshift(newUser);
                    this.totalItems++;

                    this.modalInstance.hide();

                    // Exibe o modal com a senha gerada
                    if (response.data.generated_password) {
                        this.generatedPassword = response.data.generated_password;
                        if (this.passwordModalInstance) {
                            this.passwordModalInstance.show();
                        }
                    } else {
                        this.showAlert("Usuário criado com sucesso!");
                    }
                }

            } catch (e) {
                if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    if (!validationErrors) {
                        this.showAlert("Erro de validação. Verifique os campos.", "error");
                        return;
                    }
                    let errorMsgs = "Corrija os seguintes campos:\n\n";
                    for (const campo in validationErrors) {
                        errorMsgs += `- ${validationErrors[campo][0]}\n`;
                    }
                    this.showAlert(errorMsgs, "error");
                } else {
                    this.showAlert(e.response?.data?.message || "Erro ao salvar.", "error");
                }
            } finally {
                this.loading = false;
            }
        },

        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteModal'));
            modal.show();
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/users/bulk-delete', { ids: this.selectedIds });
                    this.users = this.users.filter(u => !this.selectedIds.includes(u.id));
                    this.totalItems -= this.selectedIds.length;
                    this.showAlert(`${this.selectedIds.length} usuários excluídos.`);
                    this.selectedIds = [];
                } else {
                    await api.delete(`/users/${this.itemToDelete.id}`);
                    this.users = this.users.filter(u => u.id !== this.itemToDelete.id);
                    this.totalItems -= 1;
                    this.showAlert(`Usuário removido.`);
                }
            } catch (error) {
                if(error.status == 403){
                     this.showAlert('Você não pode excluir esse usuário por conta do perfil de acesso atrelado a ele.', 'error');
                }else{
                     this.showAlert('Erro ao excluir registro(s).', 'error');
                }
               
            } finally {
                const modalElement = document.getElementById('confirmDeleteModal');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
            }
        },

        toggleAll(e) {
            if (e.target.checked) this.selectedIds = this.users.map(u => u.id);
            else this.selectedIds = [];
        },

        copyPassword() {
            navigator.clipboard.writeText(this.generatedPassword).then(() => {
                this.showAlert("Senha copiada para a área de transferência!");
            }).catch(() => {
                this.showAlert("Falha ao copiar a senha.", "error");
            });
        },

        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';

            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'warning') icon = 'bi-exclamation-triangle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });

            const timeout = type === 'error' ? 6000 : 4000;
            setTimeout(() => this.removeAlert(id), timeout);
        },

        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },
        applyPhoneMask(e) {
            let v = e.target.value.replace(/\D/g, "");

            // Limita a 11 dígitos no total (tamanho máximo que atende Celulares e 0800)
            if (v.length > 11) {
                v = v.substring(0, 11);
            }

            // Verifica se é um número especial (0800 ou 0300)
            if (v.startsWith("0800") || v.startsWith("0300")) {
                if (v.length > 7) {
                    // Formato: 0800 000 0000
                    v = v.replace(/^(\d{4})(\d{3})(\d{0,4}).*/, "$1 $2 $3");
                } else if (v.length > 4) {
                    // Formato: 0800 000...
                    v = v.replace(/^(\d{4})(\d{0,3})/, "$1 $2");
                }
            } else {
                // Formatação Padrão: Fixo e Celular com DDD
                if (v.length > 10) {
                    // Celular: (99) 99999-9999
                    v = v.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
                } else if (v.length > 6) {
                    // Fixo completo: (99) 9999-9999
                    v = v.replace(/^(\d{2})(\d{4})(\d+)/, "($1) $2-$3");
                } else if (v.length > 2) {
                    // Apenas DDD e início do número: (99) 99...
                    v = v.replace(/^(\d{2})(\d+)/, "($1) $2");
                } else if (v.length > 0) {
                    // Apenas dígito inicial do DDD: (9
                    v = v.replace(/^(\d*)/, "($1");
                }
            }

            this.form.phone = v;
        },
    }
}
</script>

<style scoped>
/* ESTILOS IDÊNTICOS AO COMPONENTE DE ROLES */
.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}

.bg-info-subtle {
    background-color: #f0f9ff !important;
    color: #0284c7 !important;
}

.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-primary:disabled {
    opacity: 0.5;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
    animation: shake 0.4s ease-in-out;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}
</style>